<template>
  <div id="app">
    <keep-alive include="Asd20DirectorySearchPage">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'Directory',
}
</script>

<style lang="scss">
// @import '@asd20/ui/src/design/index.scss';

#app {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;

  .asd20-school-directory {
    flex-grow: 1;
  }
  .asd20-app-template__sidebar-title {
    font-size: 1rem;
    line-height: 1;
    margin: 0;
    align-items: center;
  }
  // .asd20-app-template__toolbar {
  //   flex-wrap: wrap;
  // }
}
</style>
